import React from 'react';
import { Car, DollarSign, Percent } from 'lucide-react';

const CarParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  carTypes 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Стоимость автомобиля */}
      <div>
        <label htmlFor="carPrice" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Car className="w-4 h-4 mr-2 text-indigo-500" />
          Стоимость автомобиля
        </label>
        <input
          type="text"
          id="carPrice"
          name="carPrice"
          value={formData.carPrice}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.carPrice ? 'input-error' : ''}`}
          placeholder="Введите стоимость"
        />
        {errors.carPrice && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.carPrice}
          </p>
        )}
      </div>

      {/* Первоначальный взнос */}
      <div>
        <label htmlFor="downPayment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <DollarSign className="w-4 h-4 mr-2 text-indigo-500" />
          Первоначальный взнос
        </label>
        <div className="flex">
          <input
            type="text"
            id="downPayment"
            name="downPayment"
            value={formData.downPayment}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.downPayment ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          <input
            type="text"
            id="downPaymentPercent"
            name="downPaymentPercent"
            value={formData.downPaymentPercent}
            onChange={handleInputChange}
            className={`form-input w-1/3 ml-2 ${errors.downPaymentPercent ? 'input-error' : ''}`}
            placeholder="%"
          />
          <span className="inline-flex items-center ml-1">%</span>
        </div>
        {errors.downPayment && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.downPayment}
          </p>
        )}
      </div>

      {/* Тип автомобиля */}
      <div>
        <label htmlFor="carType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Тип автомобиля
        </label>
        <div className="grid grid-cols-2 gap-2">
          {Array.isArray(carTypes) ? carTypes.map((type) => (
            <label key={type.id} className="inline-flex items-center">
              <input
                type="radio"
                name="carType"
                value={type.id}
                checked={formData.carType === type.id}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                {type.name}
              </span>
            </label>
          )) : (
            // Значения по умолчанию, если carTypes не определено
            <>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="carType"
                  value="new"
                  checked={formData.carType === 'new'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  Новый автомобиль
                </span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="carType"
                  value="used"
                  checked={formData.carType === 'used'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  Подержанный автомобиль
                </span>
              </label>
            </>
          )}
        </div>
        {errors.carType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.carType}
          </p>
        )}
      </div>

      {/* Возраст автомобиля (только для б/у) */}
      {formData.carType === 'used' && (
        <div>
          <label htmlFor="carAge" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Возраст автомобиля (лет)
          </label>
          <input
            type="text"
            id="carAge"
            name="carAge"
            value={formData.carAge}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.carAge ? 'input-error' : ''}`}
            placeholder="Введите возраст"
          />
          {errors.carAge && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.carAge}
            </p>
          )}
        </div>
      )}

      {/* Информационный блок о первоначальном взносе */}
      <div className="col-span-full mt-2">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-md">
          <div className="flex items-start">
            <Percent className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 mr-2 flex-shrink-0" />
            <div>
              <p className="text-sm text-blue-700 dark:text-blue-300">
                Обычно банки требуют первоначальный взнос не менее 10-20% от стоимости автомобиля. 
                Более высокий первоначальный взнос позволяет получить более низкую процентную ставку.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarParametersSection;